import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import OutlineStylePaper from './ToolsOutlineStyle';
import FillStylePaper from './ToolsFillStyle';

function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2} >
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width:180,
    '& .MuiBox-root':{
        padding:0,
    },
    '& .MuiTabs-root': {
        width:180,
        minHeight:32,
    },
    '& .MuiTabs-fixed': {
        width:180,
        height:28,
    },
    '& .MuiTab-root': {
        minWidth:60,
        width:90,
        minHeight:24,
        height:28,
        textTransform:'none',
        fontSize:12,
    },
    '& .MuiTabs-indicator':{
      backgroundColor: '#0C4C35',
    }
  },
  tabs: {
    color:'#000',
  },
  tabPanel:{

  }
}));

export default function ToolStylePaper(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="horizontal"
        value={value}
        onChange={handleChange}
        aria-label="Style tabs"
        className={classes.tabs}
      >
        <Tab label="Outline" {...a11yProps(0)} />
        <Tab label="Fill" {...a11yProps(1)} />
      </Tabs>
      <TabPanel className={classes.tabPanel} value={value} index={0}>
        <OutlineStylePaper activetool={props.activetool} />
      </TabPanel>
      <TabPanel className={classes.tabPanel} value={value} index={1}>
        <FillStylePaper activetool={props.activetool} />
      </TabPanel>
    </div>
  )};